export default __webpack_public_path__ + "static/m-feature-1-8a1a6e5b4c26b9f454adbae011be807a.png";